import { Button } from '@bambi/component-library/src/components/Button/Button';
import { Popover } from '@bambi/component-library/src/components/Popover/Popover';
import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';

import { AssignmentSortSelect } from './AssignmentSortSelect/AssignmentSortSelect';
import { AutoScrollCalendarToggle } from './AutoScrollCalendarToggle';
import { DownloadScheduleMenuItem } from './DownloadScheduleMenuItem';
import { RouteTemplateCreateMenuItem } from './RouteTemplatesCreateMenuItem';
import { UnassignAllTripsMenuItem } from './UnassignAllTripsMenuItem';
import { ZoomControls } from './ZoomControls';

export function DispatchCalendarHeaderMenu() {
  return (
    <Popover
      trigger={
        <Button
          variant="ghost"
          dataTestId="dispatch-calendar-header-menu-button"
        >
          <EllipsisVerticalIcon className="h-5 w-5" />
        </Button>
      }
      content={
        <div className="flex min-w-[250px] flex-col items-start gap-2 p-2">
          <h4 className="text-xs font-bold">Calendar Settings</h4>
          <ZoomControls />
          <div className="h-[1px] w-full bg-slate-400" />
          <AutoScrollCalendarToggle />
          <div className="h-[1px] w-full bg-slate-400" />
          <AssignmentSortSelect />
          <div className="h-[1px] w-full bg-slate-400" />
          <h4 className="text-xs font-bold">Calendar Features</h4>
          <RouteTemplateCreateMenuItem />
          <UnassignAllTripsMenuItem />
          <DownloadScheduleMenuItem />
        </div>
      }
    />
  );
}
